export default __webpack_public_path__ + "static/media/branding-logo.06c61883.svg";